import React from 'react';
import { List, RadioGroup, Divider } from '@material-ui/core';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import MoneyIcon from '@material-ui/icons/Money';

import PaymentMethodListItem from '../PaymentMethodListItem';

import useBooking from '../../../../../../context/useBooking';
import { PAYMENT_METHODS } from '../../../../../../context/helpers';

const PaymentMethodList = () => {
	const {
		cardPaymentsEnabled,
		cashPaymentsEnabled,
		paymentMethod,
		handleChangePaymentMethod,
	} = useBooking();

	return (
		<RadioGroup value={paymentMethod} onChange={handleChangePaymentMethod}>
			<List disablePadding>
				{cardPaymentsEnabled && (
					<PaymentMethodListItem
						value={PAYMENT_METHODS.CARD}
						title="Credit card"
						icon={CreditCardIcon}
						cardIcon
					/>
				)}
				<Divider />
				{cashPaymentsEnabled && (
					<PaymentMethodListItem
						value={PAYMENT_METHODS.CASH}
						title="Pay at pickup"
						icon={MoneyIcon}
					/>
				)}
			</List>
		</RadioGroup>
	);
};

export default PaymentMethodList;
